import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const seg = 'inline-flex h-8 items-center gap-1.5 px-2.5 text-sm whitespace-nowrap transition-colors focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)]';
const segOff = 'bg-[var(--color-surface-raised)] text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-overlay)]';
const segOn = 'bg-[color-mix(in_srgb,var(--color-brand-bg)_14%,var(--color-surface-raised))] font-medium text-[var(--color-text-primary)]';
function Count({ tab, on }) {
    if (tab.count === null || tab.count === undefined)
        return null;
    const hot = tab.tone === 'warning' && tab.count > 0;
    return (_jsx("span", { className: cn('tabular-nums', hot
            ? 'rounded-[var(--radius-2)] bg-[var(--color-state-danger-bg)] px-1.5 text-xs font-medium text-[var(--color-state-danger-fg)]'
            : on
                ? 'text-[var(--color-text-primary)]'
                : 'text-[var(--color-text-muted)]'), children: tab.count }));
}
/**
 * Вкладки-фильтры со счётчиками: слитая группа сегментов («Все 64 · Работают 18
 * · На паузе 41») и, при `detached`, отдельная кнопка справа. Это срезы одного
 * списка, а не разделы страницы, поэтому у кнопок `aria-pressed`, а не роль
 * `tab` (панелей нет). Выбор живёт у вызывающего — обычно в адресе.
 */
export function FilterTabs({ value, onChange, tabs, label, className, }) {
    const grouped = tabs.filter((t) => !t.detached);
    const detached = tabs.filter((t) => t.detached);
    return (_jsxs("div", { role: "group", "aria-label": label, className: cn('flex flex-wrap items-center gap-2', className), children: [_jsx("div", { className: "inline-flex overflow-hidden rounded-[var(--radius-3)] border border-[var(--color-border-default)] [&>*+*]:border-l [&>*+*]:border-[var(--color-border-default)]", children: grouped.map((t) => {
                    const on = t.value === value;
                    return (_jsxs("button", { type: "button", "aria-pressed": on, className: cn(seg, on ? segOn : segOff), onClick: () => onChange(t.value), children: [t.label, " ", _jsx(Count, { tab: t, on: on })] }, t.value));
                }) }), detached.map((t) => {
                const on = t.value === value;
                return (_jsxs("button", { type: "button", "aria-pressed": on, className: cn(seg, 'rounded-[var(--radius-3)] border border-[var(--color-border-default)]', on ? segOn : segOff), onClick: () => onChange(t.value), children: [t.label, " ", _jsx(Count, { tab: t, on: on })] }, t.value));
            })] }));
}
//# sourceMappingURL=filter-tabs.js.map